import { UISref } from "@uirouter/react";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { EditableField } from "../../components/forms/field";
import { AuthActions } from "../../store/auth/actions";
import { AuthDTO } from "../../store/auth/models/dto";
import { useYupValidationResolver } from "../../utils/utils";
import { Form } from "./base";

type RequestDTO = AuthDTO.Requests.AuthRequest.T;
const { useFields, defaults } = AuthDTO.Requests.AuthRequest;

export const LoginPage = () => {
  const { labels, validation } = useFields();
  const resolver = useYupValidationResolver(validation);
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<RequestDTO>({
    defaultValues: defaults,
    resolver,
  });
  const dispatch = useDispatch();

  return (
    <Form.Form
      onSubmit={handleSubmit((data) => dispatch(AuthActions.authRequest(data)))}
    >
      <h1 className="h1">Sign In</h1>
      <EditableField editing control={control} name="username">
        <Form.TextField
          fullWidth
          type="email"
          label={labels.username}
          error={!!errors.username}
          helperText={errors.username?.message}
          autoComplete="username"
        />
      </EditableField>
      <EditableField editing control={control} name="password">
        <Form.PasswordField
          obfuscating
          fullWidth
          autoComplete="current-password"
          label={labels.password}
          error={!!errors.password}
          helperText={errors.password?.message}
        />
      </EditableField>

      <Form.Smaller>
        <UISref to="^.forgot-password">
          <Form.ForgotPassword>Forgot password</Form.ForgotPassword>
        </UISref>
      </Form.Smaller>
      <Form.Login id="sign-in">Sign In</Form.Login>
      <Form.Smaller>
        Do you have an account yet?{" "}
        <UISref to="^.register">
          <a>Sign Up!</a>
        </UISref>
      </Form.Smaller>
    </Form.Form>
  );
};
